/**
 * PhotoSwipe Buy Buttons
 * Adds Add to Cart, Buy Now buttons and price to PhotoSwipe lightbox
 *
 * Clones buttons from product page and adds event handlers.
 * If elements not found - logs warning and continues without buttons.
 */

document.addEventListener("DOMContentLoaded", () => {
  if (typeof PhotoSwipeLightbox === "undefined") return;

  const cartDrawer = document.querySelector('cart-drawer');

  const lightbox = new PhotoSwipeLightbox({
    gallery: ".product-media",
    children: ".product-media__zoom",
    pswpModule: PhotoSwipe
  });

  // Buy buttons in PhotoSwipe lightbox
  lightbox.on('uiRegister', function() {
    lightbox.pswp.ui.registerElement({
      name: 'buy-buttons',
      order: 9,
      isButton: false,
      appendTo: 'root',
      onInit: (el, pswp) => {
        // Find elements on product page
        const addToCartBtn = document.querySelector('.product-form__submit');
        const buyNowBtn = document.querySelector('.buy-now__button--all') || document.querySelector('.buy-now__button--single');
        const priceEl = document.querySelector('.price__container');
        const variantInput = document.querySelector('input[name="id"]');

        // Protection: if required elements not found, log warning and exit
        if (!addToCartBtn || !priceEl || !variantInput) {
          console.warn(
            '[PhotoSwipe Buy Buttons] Required elements not found.\n' +
            'Check selectors:\n' +
            '- .product-form__submit: ' + (addToCartBtn ? 'OK' : 'NOT FOUND') + '\n' +
            '- .price__container: ' + (priceEl ? 'OK' : 'NOT FOUND') + '\n' +
            '- input[name="id"]: ' + (variantInput ? 'OK' : 'NOT FOUND') + '\n' +
            '- .buy-now__button (optional): ' + (buyNowBtn ? 'OK' : 'NOT FOUND') + '\n' +
            'Files to check:\n' +
            '- snippets/siccas-buy-buttons.liquid\n' +
            '- snippets/siccas-price.liquid\n' +
            '- snippets/siccas-product-media-gallery.liquid'
          );
          return;
        }

        // Clone elements
        const addToCartClone = addToCartBtn.cloneNode(true);
        const priceClone = priceEl.cloneNode(true);

        // Create wrapper
        el.className = 'pswp__buy-wrapper';
        el.appendChild(addToCartClone);

        if (buyNowBtn) {
          const buyNowClone = buyNowBtn.cloneNode(true);
          el.appendChild(buyNowClone);

          // Buy Now handler
          buyNowClone.addEventListener('click', async (e) => {
            e.preventDefault();
            if (buyNowClone.disabled) return;
            const variantId = variantInput ? variantInput.value : null;
            if (!variantId) return;

            try {
              await fetch('/cart/clear.js', { method: 'POST' });
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
              });
              if (response.ok) {
                window.location.href = '/checkout';
              }
            } catch (error) {
              console.error('Buy now error:', error);
            }
          });
        }

        el.appendChild(priceClone);

        // Add to Cart handler
        addToCartClone.addEventListener('click', async (e) => {
          e.preventDefault();
          if (addToCartClone.disabled) return;
          const variantId = variantInput ? variantInput.value : null;
          if (!variantId) return;

          // Loading state
          addToCartClone.classList.add('loading');

          try {
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 1);

            if (cartDrawer) {
              formData.append(
                'sections',
                cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
              );
              formData.append('sections_url', window.location.pathname);
            }

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });
            const data = await response.json();

            if (data.status) {
              console.error('Add to cart error:', data.description);
              return;
            }

            if (cartDrawer) {
              cartDrawer.renderContents(data);
              if (cartDrawer.classList.contains('is-empty')) {
                cartDrawer.classList.remove('is-empty');
              }
            }

            pswp.close();
          } catch (error) {
            console.error('Add to cart error:', error);
          } finally {
            addToCartClone.classList.remove('loading');
          }
        });
      }
    });
  });

  lightbox.init();
});
